export const APP_STORE_URL = "https://apps.apple.com/us/app/crystalhaccp/id6758110307";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.mikanao.crystalhaccp";